export const clips = [
  {
    id: "k1",
    title: "剧情回顾：苏念重返职场的第一天",
    type: "剧情回顾",
    duration: 186,
    thumbnail:
      "https://readdy.ai/api/search-image?query=Young%20woman%20walking%20into%20a%20modern%20office%20lobby%20with%20a%20laptop%20bag%2C%20warm%20morning%20light%20through%20glass%20walls%2C%20cinematic%20drama%20scene%2C%20determined%20expression%2C%20muted%20terracotta%20tones&width=800&height=450&seq=clip-01&orientation=landscape",
    description:
      "苏念时隔一年重新走进写字楼，电梯门打开的那一刻，她深吸一口气，像是给自己打气。这支片段浓缩了她从犹豫到坚定的整个过程。",
    storyId: "s2",
    views: 128000,
  },
  {
    id: "k2",
    title: "精彩对白：母亲与女儿的深夜长谈",
    type: "精彩对白",
    duration: 142,
    thumbnail:
      "https://readdy.ai/api/search-image?query=Mother%20and%20daughter%20talking%20quietly%20at%20a%20kitchen%20table%20late%20at%20night%2C%20single%20warm%20lamp%20light%2C%20intimate%20cinematic%20drama%20scene%2C%20soft%20shadows%2C%20cream%20and%20clay%20palette&width=800&height=450&seq=clip-02&orientation=landscape",
    description:
      "“妈，你当年后悔过吗？”面对女儿的提问，母亲沉默了很久。这场没有配乐的长谈，被观众称为全剧最安静也最有力量的一场戏。",
    storyId: "s6",
    views: 205000,
  },
  {
    id: "k3",
    title: "花絮：片场的一天",
    type: "花絮",
    duration: 240,
    thumbnail:
      "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20a%20family%20drama%20film%20set%2C%20crew%20adjusting%20camera%20and%20lights%20in%20a%20warm%20living%20room%20set%2C%20documentary%20style%2C%20candid%20moment%2C%20warm%20amber%20tones&width=800&height=450&seq=clip-03&orientation=landscape",
    description:
      "从清晨布置灯光到深夜收工，跟随镜头看看“年轻的母亲”剧组平凡又忙碌的一天，也看看演员们在喊“卡”之后的样子。",
    storyId: "s13",
    views: 64000,
  },
  {
    id: "k4",
    title: "剧情回顾：那场雨中的和解",
    type: "剧情回顾",
    duration: 168,
    thumbnail:
      "https://readdy.ai/api/search-image?query=Two%20people%20with%20umbrellas%20talking%20on%20a%20rainy%20street%20at%20night%2C%20warm%20streetlights%20reflecting%20on%20wet%20asphalt%2C%20emotional%20cinematic%20drama%20scene%2C%20amber%20rain%20tones&width=800&height=450&seq=clip-04&orientation=landscape",
    description:
      "多年以后，苏念与沈予安在雨里把话说开。没有指责，只有释怀。这支片段记录了全剧最让人心软的一次告别。",
    storyId: "s11",
    views: 173000,
  },
  {
    id: "k5",
    title: "精彩对白：婆媳之间的分寸",
    type: "精彩对白",
    duration: 95,
    thumbnail:
      "https://readdy.ai/api/search-image?query=An%20older%20woman%20and%20a%20younger%20woman%20having%20a%20tense%20but%20tender%20conversation%20at%20a%20dining%20table%2C%20warm%20interior%20light%2C%20cinematic%20drama%20scene%2C%20clay%20and%20cream%20palette&width=800&height=450&seq=clip-05&orientation=landscape",
    description:
      "“妈也是第一次当奶奶。”秦姨的一句话，让剑拔弩张的餐桌安静下来。短短一分半，道尽两代人的分寸与体谅。",
    storyId: "s3",
    views: 98000,
  },
  {
    id: "k6",
    title: "花絮：小演员果果的第一次哭戏",
    type: "花絮",
    duration: 132,
    thumbnail:
      "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20with%20a%20child%20actor%20on%20a%20warm%20film%20set%2C%20director%20kneeling%20and%20talking%20to%20a%20little%20girl%2C%20documentary%20style%2C%20soft%20lighting%2C%20tender%20moment&width=800&height=450&seq=clip-06&orientation=landscape",
    description:
      "为了拍好回忆线里的一场哭戏，导演陪着小演员果果聊了很久。镜头里是表演，镜头外是所有人小心翼翼守护的那份真诚。",
    storyId: "s9",
    views: 52000,
  },
  {
    id: "k7",
    title: "剧情回顾：深夜急诊室",
    type: "剧情回顾",
    duration: 210,
    thumbnail:
      "https://readdy.ai/api/search-image?query=Hospital%20emergency%20corridor%20at%20night%20with%20a%20family%20waiting%20anxiously%2C%20soft%20warm%20clinical%20lighting%2C%20emotional%20cinematic%20drama%20scene%2C%20muted%20neutral%20tones&width=800&height=450&seq=clip-07&orientation=landscape",
    description:
      "孩子高烧的那个夜晚，苏念独自抱着她冲向医院。走廊尽头的灯很亮，她的影子却很小。这支片段看哭了无数观众。",
    storyId: "s4",
    views: 241000,
  },
  {
    id: "k8",
    title: "精彩对白：写给五年后的信",
    type: "精彩对白",
    duration: 118,
    thumbnail:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20handwritten%20letter%20on%20a%20desk%20with%20warm%20lamp%20light%2C%20a%20woman%20writing%20in%20the%20background%20blurred%2C%20intimate%20cinematic%20drama%20scene%2C%20cream%20and%20sepia%20tones&width=800&height=450&seq=clip-08&orientation=landscape",
    description:
      "“愿你长大后，也能勇敢地成为你自己。”苏念写给女儿、也写给自己的这封信，是特别篇最动人的收尾。",
    storyId: "s13",
    views: 156000,
  },
  {
    id: "k9",
    title: "花絮：主创聊创作初衷",
    type: "花絮",
    duration: 305,
    thumbnail:
      "https://readdy.ai/api/search-image?query=Interview%20set%20with%20director%20and%20producer%20sitting%20in%20warm%20studio%20chairs%2C%20soft%20key%20light%2C%20documentary%20interview%20style%2C%20neutral%20warm%20backdrop%2C%20thoughtful%20atmosphere&width=800&height=450&seq=clip-09&orientation=landscape",
    description:
      "导演与编剧坐下来聊聊，为什么要拍一部关于“年轻的母亲”的故事。他们说，想记录那些被忽略的、日常里的英雄主义。",
    storyId: "s12",
    views: 71000,
  },
  {
    id: "k10",
    title: "剧情回顾：学区房风波",
    type: "剧情回顾",
    duration: 156,
    thumbnail:
      "https://readdy.ai/api/search-image?query=A%20couple%20discussing%20house%20documents%20at%20a%20kitchen%20table%20at%20night%2C%20calculator%20and%20papers%2C%20warm%20lamp%20light%2C%20cinematic%20drama%20scene%2C%20muted%20amber%20tones&width=800&height=450&seq=clip-10&orientation=landscape",
    description:
      "为了孩子上学，一张报价单摆在了夫妻俩面前。争执、沉默、妥协，最后他们选择了一家人能喘得过气的那条路。",
    storyId: "s10",
    views: 112000,
  },
  {
    id: "k11",
    title: "精彩对白：旧友重逢",
    type: "精彩对白",
    duration: 88,
    thumbnail:
      "https://readdy.ai/api/search-image?query=Two%20old%20friends%20meeting%20in%20a%20sunlit%20cafe%20by%20a%20large%20window%2C%20coffee%20cups%2C%20gentle%20smiles%2C%20cinematic%20drama%20scene%2C%20warm%20afternoon%20light%2C%20creamy%20terracotta%20palette&width=800&height=450&seq=clip-11&orientation=landscape",
    description:
      "“你还是那个会把所有事都扛在肩上的人。”多年未见的朋友一眼看穿了苏念，这句台词成为许多观众的共鸣点。",
    storyId: "s5",
    views: 88000,
  },
  {
    id: "k12",
    title: "花絮：幕后美术特辑",
    type: "花絮",
    duration: 275,
    thumbnail:
      "https://readdy.ai/api/search-image?query=Art%20department%20building%20a%20warm%20family%20apartment%20film%20set%2C%20props%20and%20fabric%20samples%2C%20behind%20the%20scenes%20documentary%20style%2C%20soft%20studio%20light%2C%20earthy%20terracotta%20tones&width=800&height=450&seq=clip-12&orientation=landscape",
    description:
      "剧组如何用一块桌布、一盏台灯还原出一个“像一个家”的空间？美术团队带你走进布景背后的细节。",
    storyId: "s1",
    views: 39000,
  },
  {
    id: "k13",
    title: "剧情回顾：初为人母的清晨",
    type: "剧情回顾",
    duration: 175,
    thumbnail:
      "https://readdy.ai/api/search-image?query=Warm%20early%20morning%20in%20a%20cozy%20home%2C%20a%20young%20mother%20holding%20a%20baby%20near%20a%20sunlit%20window%2C%20cinematic%20drama%20scene%2C%20soft%20golden%20light%2C%20cream%20and%20terracotta%20tones&width=800&height=450&seq=clip-13&orientation=landscape",
    description:
      "全剧的开场，也是所有故事的起点。天刚亮，孩子醒了，年轻的母亲第一次独自面对属于自己的清晨。",
    storyId: "s1",
    views: 264000,
  },
];